// eslint-disable-next-line import/prefer-default-export
export const btoaWithCatch = data => {
  try {
    return btoa(data);
  } catch (error) {
    return data;
  }
};
